/** How member names are shown across Recovery Commons (first name + last initial). */

export const DISPLAY_NAME_LABEL = 'Display name (first name and last initial)';
export const DISPLAY_NAME_PLACEHOLDER = 'e.g. John D';
export const DISPLAY_NAME_HINT =
  'How you appear to other members — first name and last initial only (e.g. John D).';
